/* Adapter/Proxy to the Reservation APi from RezApi */
// import axios, { AxiosRequestConfig } from 'axios'

import type { AxiosInstance, AxiosResponse } from 'axios'
import axios from 'axios'
import { BearerToken } from '../configs/constant'

class ApiClient {
  readonly client: AxiosInstance

  constructor(baseURL: string) {
    this.client = axios.create({
      baseURL
    })
  }

  async get<T>(endpoint: string): Promise<T> {
    try {
      const response: AxiosResponse<T> = await this.client.get(endpoint, {
        headers: {
          Authorization: `Bearer ${this.getAuthToken()}`
        },
        withCredentials: false
      })
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error)
      throw error
    }
  }

  async post<K, T>(endpoint: string, request: K): Promise<T | undefined> {
    try {
      const response: AxiosResponse<T> = await this.client.post(endpoint, request, {
        headers: {
          Authorization: `Bearer ${this.getAuthToken()}`
        },
        withCredentials: false
      })
      return response.data
    } catch (error) {
      console.error('Error fetching data:', error)
      throw error
    }
  }

  private getAuthToken(): string {
    const urlParams = new URLSearchParams(window.location.search)
    const token: string | null = urlParams.get(BearerToken)
    return token ?? ''
  }
}
export default ApiClient
